// extracted by mini-css-extract-plugin
export var acceptButton = "_1a-5";
export var fullContent = "_1a-4";
export var link = "_1a-6";
export var linkIcon = "_1a-7";
export var sideContent = "_1a-3";
export var sideImage = "_1a-2";
export var sideImageWrapper = "_1a-1";
export var splitLayout = "_1a-0";